import { Avatar, type SxProps } from '@mui/material';

import PonduranceIcon from '@/components/PonduranceIcon';
import { getUserInitials, stringToColor } from '@/utils/Common.utils';

import useStyles from './UserAvatar.styles';
import type { UserAvatarProps } from './UserAvatar.types';

export const UserAvatar = ({
  name,
  icon,
  size = 'md',
  colorize = false,
  pondurance
}: UserAvatarProps) => {
  const { classes } = useStyles();

  const sx: SxProps = colorize
    ? { bgcolor: `${stringToColor(name)} !important` }
    : { height: 28, width: 28, fontSize: '0.625rem' };

  switch (size) {
    case 'sm':
      sx.height = 24;
      sx.width = 24;
      sx.fontSize = '0.625rem';
      break;
    case 'lg':
      sx.height = 36;
      sx.width = 36;
      sx.fontSize = '0.75rem';
      break;
    default:
      sx.height = 28;
      sx.width = 28;
      sx.fontSize = '0.625rem';
      break;
  }

  return (
    <Avatar className={classes.userAvatar} sx={sx}>
      {icon || getUserInitials(name)}
      {pondurance && <PonduranceIcon background offset size="sm" />}
    </Avatar>
  );
};

export default UserAvatar;
